import { headingText } from '../utils/headingText';
export default function Footer() {
  return (
    <footer className="bg-brand-black text-white py-12">
      <div className="container mx-auto px-6 md:px-12 flex flex-col lg:flex-row justify-evenly">

        {/* Subscribe Section */}
        <div className="mb-8 md:mb-0">
          <h3 className="text-2xl font-bold mb-4 text-white">{headingText("Subscribe for Updates")}</h3>
          <form
            action="https://syncstrategicdigital.us22.list-manage.com/subscribe/post?u=f86b430cff29942a29e1896ee&id=d0770b91d1&f_id=008bc2e1f0"
            method="POST"
            target="_blank"
            className="flex flex-col sm:flex-row gap-4"
          >
            <input
              type="email"
              name="EMAIL"
              required
              aria-label="Email address for newsletter"
              placeholder="Your email address"
              className="px-4 py-2 rounded-md text-gray-900 focus:outline-none"
            />
            <input type="hidden" name="tags" value="413" />
            <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
              <input type="text" name="b_f86b430cff29942a29e1896ee_d0770b91d1" tabIndex="-1" defaultValue="" />
            </div>
            <button
              type="submit"
              className="btn-secondary"
            >
              Subscribe
            </button>
          </form>
        </div>

        {/* Links Section */}
        <div className="flex flex-col md:flex-row gap-8 mt-8">
          {/* Main Navigation */}
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-brand-pink">Home</a></li>
              <li><a href="/about" className="hover:text-brand-pink">About</a></li>
              <li><a href="/insights" className="hover:text-brand-pink">Insights</a></li>
              <li><a href="/sync-framework" className="hover:text-brand-pink">Sync Framework</a></li>
              <li><a href="/services" className="hover:text-brand-pink">Services</a></li>
              <li><a href="/how-we-work-together" className="hover:text-brand-pink">How We Work Together</a></li>
              <li><a href="/contact" className="hover:text-brand-pink">Contact</a></li>
            </ul>
          </div>
      </div>

      {/* Copyright / Legal Navigation */}
      <div className="border-t border-gray-700 mt-12 pt-6 text-center text-sm text-gray-500">
      <p className="mt-8">
        © {new Date().getFullYear()} Reison Holdings LLC dba Sync Strategic Digital
      </p>

      </div>
    </footer>
  );
}
